"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[277],{

/***/ 5453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1720);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _TransparentBackground__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6220);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 400px;\n  padding: 15px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const Modal = (param)=>{
    let { show , onClose , children , modalId  } = param;
    const [isBrowser, setIsBrowser] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setIsBrowser(true);
    }, []);
    const handleCloseClick = (e)=>{
        e.preventDefault();
        onClose();
    };
    const modalContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_TransparentBackground__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                onClick: handleCloseClick,
                show: show
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledModal, {
                className: "absolute top-0 w-[21rem] translate-x-[calc(50vw_-_10.5rem)] border bg-gray-100 duration-300 ease-in-out dark:border-gray-700 dark:bg-gray-900 sm:translate-x-[calc(50vw_-_10.5rem)] lg:w-1/3 lg:translate-x-[calc(50vw_-_100vw*1/6)] xl:w-1/4 xl:translate-x-[calc(50vw_-_100vw*1/8)] ".concat(show ? "translate-y-[calc(20vh)] opacity-100" : "-translate-y-full opacity-0"),
                children: children
            })
        ]
    });
    if (isBrowser) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__["default"].createPortal(modalContent, document.getElementById(modalId));
    } else {
        return null;
    }
};
const StyledModal = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ }),

/***/ 6277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ StatsModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _components_modals_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5453);


function StatsModal(param) {
    let { setRankingModal , showRankingModal , totalStats  } = param;
    const statsView = ()=>{
        const initialValue = 0;
        const sumWithInitial = totalStats.rounds.reduce((previousValue, currentValue)=>previousValue + currentValue, initialValue);
        if (sumWithInitial > 0) {
            return totalStats.rounds.map((item, index)=>{
                const width = item / totalStats.won * 100 || 0;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: "mx-3 flex gap-3 xl:mx-7",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                            children: [
                                index + 1,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: "h-full w-full bg-gray-400 text-right dark:bg-gray-700",
                            style: {
                                width: "".concat(width, "%")
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                className: "p-3",
                                children: item > 0 && item
                            })
                        })
                    ]
                }, index);
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "mt-5 text-center font-semibold",
                children: "No win data availabe."
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_modals_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        onClose: ()=>setRankingModal(false),
        show: showRankingModal,
        modalId: "modal-root",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
            className: "flex h-full flex-col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: "flex justify-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: "m-3 flex-1 pl-7",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h2", {
                                className: "text-center font-semibold text-gray-600 dark:text-gray-400",
                                children: "STATS"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: "flex justify-self-end",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                "aria-label": "Close stats modal",
                                onClick: ()=>{
                                    setRankingModal(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
                                    className: "h-6 w-6",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "gray",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: "flex h-full flex-col gap-3 pt-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                            className: "mx-2 flex justify-center gap-10 text-sm",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                    className: "flex flex-col gap-2 ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                            children: "Played"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                            className: "text-center text-xl",
                                            children: totalStats.played
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                    className: "flex flex-col gap-2 ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                            children: "Avg. Round Win"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                            className: "text-center text-xl",
                                            children: totalStats.avgRoundWin
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                    className: "flex flex-col gap-2 ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                            children: "Won"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                            className: "text-center text-xl",
                                            children: totalStats.won
                                        })
                                    ]
                                })
                            ]
                        }),
                        statsView()
                    ]
                })
            ]
        })
    });
}


/***/ })

}]);